import React from 'react';
import { ScreenProps } from '../ScreenBase';
import styles from './scalegroup.module.css';
import NextButton from '../NextButton';

class ScaleGroup extends React.Component<ScreenProps> {
  state: { value: { [key: string]: number } } = {
    value: {},
  };

  setValue = (id: number, value?: number) => {
    this.setState({ value: { ...this.state.value, [id]: value } });
  };

  onSubmit = () => {
    const { onSubmit } = this.props;
    onSubmit({
      meta: this.state.value,
    });
  };

  canContinue = () => {
    const {
      data: { children },
    } = this.props;

    return Object.keys(this.state.value).length === (children ?? []).length;
  };

  render() {
    const {
      data: { min_value, max_value, extended_props, children },
    } = this.props;
    const { button_text } = extended_props || {};
    const numbers = Array.from(
      new Array((max_value || 10) - (min_value || 0) + 1),
      (x, i) => i + (min_value || 0)
    );

    return (
      <>
        <div className={styles.tableContainer}>
          <table>
            <tbody>
              {(children || []).map((c) => {
                return (
                  <tr>
                    <td className={styles.titleCell}>{c.title}</td>
                    {numbers.map((i) => (
                      <td
                        className={`${
                          this.state.value[c.id.toString()] === i
                            ? styles.selected
                            : ''
                        }`}
                        onClick={() => this.setValue(c.id, i)}
                      >
                        {i}
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <NextButton
          visible={this.canContinue()}
          onClick={this.onSubmit}
          text={button_text}
        />
      </>
    );
  }
}

export default ScaleGroup;
